"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var vee_validate_1 = require("vee-validate");
var zip_utils_1 = __importDefault(require("../../utils/zip_utils"));
var data_parser_1 = __importDefault(require("../../../common/src/utils/validation/data_parser"));
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var ShippingAddressInfo = /** @class */ (function (_super) {
    __extends(ShippingAddressInfo, _super);
    function ShippingAddressInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {
            companyName: '',
            officeName: '',
            zip1: '',
            zip2: '',
            address1: '',
            address2: '',
            address3: '',
            tel: '',
            shippingAddressInfoPersonLastName: '',
            shippingAddressInfoPersonFirstName: '',
            shippingAddressInfoCompanySameToOfficeInfo: '',
            shippingAddressInfoOfficeSameToOfficeInfo: '',
            shippingAddressInfoAddressSameToOfficeInfo: '',
            shippingAddressInfoTelSameToOfficeInfo: '',
            shippingAddressInfoPersonNameSameToOfficeInfo: ''
        };
        _this.officeInfo = {
            corporateName: '',
            officeName: '',
            zip1: '',
            zip2: '',
            address1: '',
            address2: '',
            address3: '',
            tel: '',
            requestPersonLastName: '',
            requestPersonFirstName: ''
        };
        _this.companyDisabled = false;
        _this.officeDisabled = false;
        _this.addressDisabled = false;
        _this.telDisabled = false;
        _this.personNameDisabled = false;
        return _this;
    }
    ShippingAddressInfo.prototype.setInitialData = function (data) {
        var self_ = this;
        Object.keys(this.officeInfo).forEach(function (key) {
            self_.officeInfo[key] = data[key];
        });
        if (value_checker_1.default.isPresent(this.form.shippingAddressInfoCompanySameToOfficeInfo)) {
            this.companySameToOffice();
        }
        if (value_checker_1.default.isPresent(this.form.shippingAddressInfoOfficeSameToOfficeInfo)) {
            this.officeSameToOffice();
        }
        if (value_checker_1.default.isPresent(this.form.shippingAddressInfoAddressSameToOfficeInfo)) {
            this.addressSameToOffice();
        }
        if (value_checker_1.default.isPresent(this.form.shippingAddressInfoTelSameToOfficeInfo)) {
            this.telSameToOffice();
        }
        if (value_checker_1.default.isPresent(this.form.shippingAddressInfoPersonNameSameToOfficeInfo)) {
            this.personNameSameToOffice();
        }
    };
    ShippingAddressInfo.prototype.companySameToOffice = function () {
        this.companyDisabled = true;
        this.form.companyName = this.officeInfo.corporateName;
    };
    ShippingAddressInfo.prototype.companySameToOfficeChange = function () {
        if (value_checker_1.default.isPresent(this.form.shippingAddressInfoCompanySameToOfficeInfo)) {
            this.companySameToOffice();
        }
        else {
            this.companyDisabled = false;
            this.form.companyName = '';
        }
    };
    ShippingAddressInfo.prototype.officeSameToOffice = function () {
        this.officeDisabled = true;
        this.form.officeName = this.officeInfo.officeName;
    };
    ShippingAddressInfo.prototype.officeSameToOfficeChange = function () {
        if (value_checker_1.default.isPresent(this.form.shippingAddressInfoOfficeSameToOfficeInfo)) {
            this.officeSameToOffice();
        }
        else {
            this.officeDisabled = false;
            this.form.officeName = '';
        }
    };
    ShippingAddressInfo.prototype.addressSameToOffice = function () {
        this.addressDisabled = true;
        this.form.zip1 = this.officeInfo.zip1;
        this.form.zip2 = this.officeInfo.zip2;
        this.form.address1 = this.officeInfo.address1;
        this.form.address2 = this.officeInfo.address2;
        this.form.address3 = this.officeInfo.address3;
    };
    ShippingAddressInfo.prototype.addressSameToOfficeChange = function () {
        if (value_checker_1.default.isPresent(this.form.shippingAddressInfoAddressSameToOfficeInfo)) {
            this.addressSameToOffice();
        }
        else {
            this.addressDisabled = false;
            this.form.zip1 = '';
            this.form.zip2 = '';
            this.form.address1 = '';
            this.form.address2 = '';
            this.form.address3 = '';
        }
    };
    ShippingAddressInfo.prototype.telSameToOffice = function () {
        this.telDisabled = true;
        this.form.tel = this.officeInfo.tel;
    };
    ShippingAddressInfo.prototype.telSameToOfficeChange = function () {
        if (value_checker_1.default.isPresent(this.form.shippingAddressInfoTelSameToOfficeInfo)) {
            this.telSameToOffice();
        }
        else {
            this.telDisabled = false;
            this.form.tel = '';
        }
    };
    ShippingAddressInfo.prototype.personNameSameToOffice = function () {
        this.personNameDisabled = true;
        this.form.shippingAddressInfoPersonLastName = this.officeInfo.requestPersonLastName;
        this.form.shippingAddressInfoPersonFirstName = this.officeInfo.requestPersonFirstName;
    };
    ShippingAddressInfo.prototype.personNameSameToOfficeChange = function () {
        if (value_checker_1.default.isPresent(this.form.shippingAddressInfoPersonNameSameToOfficeInfo)) {
            this.personNameSameToOffice();
        }
        else {
            this.personNameDisabled = false;
            this.form.shippingAddressInfoPersonLastName = '';
            this.form.shippingAddressInfoPersonFirstName = '';
        }
    };
    ShippingAddressInfo.prototype.setData = function (data) {
        var self_ = this;
        Object.keys(this.form).forEach(function (key) {
            self_.form[key] = data[key];
            // DBには、半角空白で保存されている場合があるので、TRIM しておく
            if (self_.form[key]) {
                self_.form[key] = self_.form[key].trim();
            }
        });
    };
    ShippingAddressInfo.prototype.zipChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getJusyo()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ShippingAddressInfo.prototype.getJusyo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var zipcode, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        zipcode = String(this.form.zip1) + String(this.form.zip2);
                        if (!zip_utils_1.default.isValid(zipcode)) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, zip_utils_1.default.getAddress(zipcode)];
                    case 1:
                        res = _a.sent();
                        this.form.address1 = res['address1'];
                        this.form.address2 = res['address2'];
                        if (res['address3']) {
                            this.form.address2 = res['address2'] + " " + res['address3'];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ShippingAddressInfo.prototype.mounted = function () {
        // Do Nothing..
    };
    ShippingAddressInfo.prototype.refs = function () {
        return this.$refs;
    };
    ShippingAddressInfo.prototype.submit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var hasError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        return [4 /*yield*/, this.refs().inputObserver.validate()];
                    case 1:
                        hasError = !(_a.sent());
                        if (hasError) {
                            this.$emit('error-occured');
                            return [2 /*return*/];
                        }
                        this.$emit('error-fixed');
                        this.form.companyName = data_parser_1.default.parseCompanyName(this.form.companyName);
                        this.form.officeName = data_parser_1.default.parseCompanyName(this.form.officeName);
                        this.form.zip1 = data_parser_1.default.toHankaku(this.form.zip1);
                        this.form.zip2 = data_parser_1.default.toHankaku(this.form.zip2);
                        this.form.address1 = data_parser_1.default.toHankaku(this.form.address1);
                        this.form.address2 = data_parser_1.default.toHankaku(this.form.address2);
                        this.form.address3 = data_parser_1.default.toHankaku(this.form.address3);
                        this.form.tel = data_parser_1.default.parseTell(this.form.tel);
                        this.$emit('submit-complete', { component: 'shippingAddressInfo', data: this.form });
                        return [2 /*return*/];
                }
            });
        });
    };
    ShippingAddressInfo.prototype.back = function (event) {
        event.preventDefault();
        this.$emit('on-back', { component: 'shippingAddressInfo', data: this.form });
    };
    __decorate([
        vue_property_decorator_1.Prop({
            default: function () {
            }
        })
    ], ShippingAddressInfo.prototype, "getMessage", void 0);
    ShippingAddressInfo = __decorate([
        vue_property_decorator_1.Component({
            components: {
                ValidationProvider: vee_validate_1.ValidationProvider,
                ValidationObserver: vee_validate_1.ValidationObserver
            }
        })
    ], ShippingAddressInfo);
    return ShippingAddressInfo;
}(vue_property_decorator_1.Vue));
exports.default = ShippingAddressInfo;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/contract_form/ShippingAddressInfo.vue
// module id = absZ
// module chunks = 1